import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=aa005bbc"
import script from "./Bag.vue?vue&type=script&lang=js"
export * from "./Bag.vue?vue&type=script&lang=js"
import style0 from "./Bag.vue?vue&type=style&index=0&id=aa005bbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports